import isSafeRedirect from './isSafeRedirect'

export default isSafeRedirect
